import React from "react";

import { MarginaliaGroup } from "../../../components/ContentBuilder/MarginaliaGroup/MarginaliaGroup";
import { MarginaliaTitle } from "../../../components/ContentBuilder/MarginaliaTitle/MarginaliaTitle";
import { MarginaliaButton } from "../../../components/ContentBuilder/MarginaliaButton/MarginaliaButton";
import { MarginaliaList } from "../../../components/ContentBuilder/MarginaliaList/MarginaliaList";
import { MarginaliaData } from "../../../components/ContentBuilder/ContentBuilder.type";

import { downloadTopicPdf } from "./downloadFile";

// Topic PDF in public/files/pdf; the download button is hidden while this is undefined.
const TOPIC_PDF_FILENAME: string | undefined = "applia-home-appliance-monitor-2025-trade.pdf";

export const tradePageMarginalia: MarginaliaData = {
	component: MarginaliaGroup,
	props: {
		children: [
			<MarginaliaTitle key="on-this-page-title" title="On this page" />,
			<MarginaliaList
				key="on-this-page-list"
				items={[
					{
						label: "Large appliances sold globally",
						scrollTo: "trade-large-appliances-sold-globally",
					},
					{
						label: "Import and export of home appliances by continent",
						scrollTo: "trade-import-export-by-continent",
					},
					{
						label: "Evolution of import and export",
						scrollTo: "trade-evolution-import-export",
					},
					{
						label: "Share of appliances imported from within Europe",
						scrollTo: "trade-share-chart-1",
					}
				]}
			/>,
			<div key="topic-download-spacer" className="mt-3">
				<MarginaliaTitle title="Topic download" />
			</div>,
			...(TOPIC_PDF_FILENAME ? [<MarginaliaButton key="download" variant="download" icon="document" label="Trade" sublabel="PDF" onClick={() => downloadTopicPdf(TOPIC_PDF_FILENAME)} />] : []),
			<MarginaliaButton key="copy" variant="copy" label="Copy link to this topic" clickedLabel="Link copied" onClick={() => navigator.clipboard.writeText(window.location.href)} />,
		],
	},
};
